import React from "react";
import UomController from "./UomController";
import ReusableModal from "../../ManageSettings/ReusableModal";
import "./UomStyle.css";
import selectIcon from "../../../../../assets/Image/SelectClear.png";
import { Autocomplete, FormControl, MenuItem, TextField } from "@mui/material";
import DotPagination from "./DotPagination";
import PaginatedSearchSelect from "../../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
const UomView = ({ show, handleClose, onUomAdded }) => {
  const {
    handleAddUom,
    uomDataList = [],
    uomDataStore = [],
    handleRemoveFromList,
    selectedUomsList = [],
    selectedUomsToDelete,
    handleUomSelectForDeletion,
    handleDeleteSelectedUoms,
    handleClearUom,
    fetchUomData,
    loading,
    setSearchQuery,
    handleUomSelect,
    pageCount,
    currentPage,
    handlePageChange,
    handleUomSelectMultiple
  } = UomController();
  const handleSubmit = async () => {
    await handleAddUom();
    if (onUomAdded) {
      onUomAdded();
      handleClearUom();
    }
  };
    const { GetPaginatedData } = useApi();

  return (
    <ReusableModal
      title="Add UOM"
      show={show}
      handleClose={handleClose}
      width="600px"
      height="590px"
    >
      <form>
        <div className="product-form">
          <div className="product-form-fields">
            <div className="form-group product-field">
               <PaginatedSearchSelect
        api="allUomData"
        GetPaginatedData={GetPaginatedData}
        getOptionLabel={(opt) => opt.uom_title || ""}
         onSelect={handleUomSelectMultiple}
        placeholder="Select Uom"
        pageSize={10}
        disabled={loading}
      //  closeDropdownTrigger={!show} 
      />
             
            </div>
          </div>
        </div>

        <div className="selected-uoms-section" style={{ marginTop: "20px" }}>
          <div className="uom-list">
            {Array.isArray(selectedUomsList) &&
              selectedUomsList.map((uom) => (
                <div className="uom-card" key={uom.id}>
                  <span className="uom-title">{uom.uom_title}</span>
                  <img
                    src={selectIcon}
                    alt="Remove"
                    className="remove-uom-icon"
                    onClick={() => handleRemoveFromList(uom.id)}
                  />
                </div>
              ))}
          </div>
        </div>

        <div className="submit-section">
          <button
            type="button"
            className="form-btn uom-add-btn"
            onClick={handleSubmit}
          >
            Add
          </button>
        </div>

        <hr className="section-divider" />
        <div className="store-uoms-list">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <h4 className="uom-section-title">
                {selectedUomsToDelete.length > 0 ? "Delete UOM" : "Manage UOM"}
              </h4>
              <div className="uom-list">
                {uomDataStore.map((uom) => (
                  <div
                    className={`uom-card ${
                      selectedUomsToDelete.includes(uom.id)
                        ? "selected-for-deletion"
                        : ""
                    }`}
                    key={uom.id}
                    onClick={() => handleUomSelectForDeletion(uom.id)}
                  >
                    <span className="uom-title">{uom.uom_title}</span>
                    <img
                      src={selectIcon}
                      alt="Select"
                      className="remove-uom-icon"
                    />
                  </div>
                ))}
              </div>

              <div className="form-actions">
                <button
                  type="button"
                  className={`form-btn delete-btn-uom ${
                    selectedUomsToDelete.length > 0 ? "active" : ""
                  }`}
                  onClick={handleDeleteSelectedUoms}
                  disabled={selectedUomsToDelete.length === 0}
                >
                  Delete
                </button>
              </div>

              {uomDataStore.length > 0 && (
                <div className="pagination-section">
                  <DotPagination
                    currentPage={currentPage}
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </form>
    </ReusableModal>
  );
};

export default UomView;
